import Marionette from 'backbone.marionette';

import template from '../templates/preferencesModal.ejs';
import alertTemplate from '../templates/alert.ejs';
import MemberModel from "./MemberModel";
import _ from "underscore-contrib";

export default Marionette.View.extend( {
   template: template,

   ui: {
      interests: '[data-manage-interest]',
      tags: '[data-manage-tag]',
      email: '#manage-email-address',
      manageSubmit: '#manage-submit'
   },

   events: {
      'submit': 'preferencesSubmitted',
      'change @ui.email': 'updateEmail',
      'change @ui.tags': 'tagsChanged',
      'change @ui.interests': 'interestsChanged'
   },

   regions: {
      alert: '#manage-alert'
   },

   initialize: function ( options ) {
      this.mergeOptions( options, ['app'] );

      this.validator = new MemberModel();
      this.listenTo( this.validator, 'invalid', () => {
         this.getUI( 'email' ).addClass( 'is-invalid' ).next().show();
      } );
      this.listenTo( this.validator, 'change:email_address', () => {
         this.getUI( 'email' ).removeClass( 'is-invalid' ).addClass( 'is-valid' ).next().hide();
      } );
   },

   templateContext: function () {
      const allInterests = _.flatten(_.walk.pluckRec(this.app.data, 'interests'));
      const activeInterests = this.model.get('interests');
      const activeTags = this.model.get('tags');
      const ret = {
         interests: !activeInterests ? [] : allInterests.filter(function (interest) {
            return !!activeInterests[interest.id]
         })
      };
      ret.interests = ret.interests.map(function (interest) {
         const tags = interest.tags?.filter(function (tagName) {
            return !!activeTags[tagName]
         })
         return { ...interest, tags };
      });
      return ret;
   },

   /**
    * Get all interests for all sections and categories that have been set in configure.json
    * @returns {Array<{id: string, name: string, tags: Array<{id: string, name: string}>}>}
    */
   _getAllConfiguredInterests: function () {
      return _.flatten(_.walk.pluckRec(this.app.data, 'interests'));
   },

   /**
    * @param {JQuery.Event} event
    */
   interestsChanged: function (event) {
      /** @type boolean */
      const checked = event.currentTarget.checked;

      if (checked) {
         const allInterests = this._getAllConfiguredInterests();
         allInterests.forEach(interest => {
            if (interest.id === event.currentTarget.name && interest.tags) {
               this.getUI('tags').each(function () {
                  if (interest.tags.includes(this.name)) {
                     this.checked = true;
                  }
               });
            }
         });
      }
   },
   tagsChanged: function (event) {
      const checked = event.currentTarget.checked;

      if (!checked) {
         const allInterests = this._getAllConfiguredInterests();
         const interest = allInterests.find(interest => interest.tags?.includes(event.currentTarget.name));
         interest && this.getUI('interests').each(function () {
            if (this.name === interest.id) {
               this.checked = false;
            }
         });
      }
   },

   updateEmail: function ( event ) {
      this.validator.set( 'email_address', event.target.value, {validate: true} );
   },

   preferencesSubmitted: function () {
      if( this.getUI( 'manageSubmit' ).hasClass( 'disabled' ) ) {
         return false
      }
      this.getUI( 'manageSubmit' ).addClass( 'loading disabled' );

      const emailAddress = this.getUI( 'email' ).val().trim();

      if( emailAddress !== this.model.get( 'email_address' ) && this.model.subscriberExists ) {
         new MemberModel( {}, {listId: this.app.data.listId} ).save( {
            email_address: this.model.get( 'email_address' ),
            status: 'unsubscribed'
         } );
      }
      // A list where checked interests are set to false.
      const changedInterests = this.getUI( 'interests' ).get().reduce( ( result, checkbox ) => {
         // If checkbox is checked then set interest to false
         return checkbox.checked ? Object.assign( result, {[checkbox.name]: false} ) : result
      }, {} );
      // A list where checked interests are set to false.
      const changedTags= this.getUI( 'tags' ).get().reduce( ( result, checkbox ) => {
         // If checkbox is checked then set interest to false
         return checkbox.checked ? Object.assign( result, {[checkbox.name]: false} ) : result
      }, {} );

      // Always a PUT request b/c ID is set when email is set. PUT will create or update existing on server.
      this.model.save({
         email_address: emailAddress,
         status: 'subscribed',
         interests: { ...this.model.get('interests'), ...changedInterests },
         tags: { ...this.model.get('tags'), ...changedTags },
      }, {
         wait: true,
         patch: true,
         success: this.preferencesSaved.bind( this ),
         error: this.preferencesError.bind( this ),
      } );
      return false
   },

   preferencesSaved: function ( model ) {
      this.getUI( 'manageSubmit' ).removeClass( 'loading disabled' );

      this.app.showAlert( 'alert-success', this.app.data.alerts.manageSuccess );

      this.app.getRegion( 'modal' ).empty(); // Close the modal and destroy this view.
   },

   preferencesError: function ( model, response ) {
      this.getUI( 'manageSubmit' ).removeClass( 'loading disabled' );

      if( response.status === 0 ) {
         this._showError( this.app.data.alerts.networkError );
      }
      else {
         this._showError( this.app.data.alerts.applicationError );
      }
   },

   _showError: function ( message ) {
      this.getRegion( 'alert' ).show( {
         template: alertTemplate,
         templateContext: {
            alertClass: 'alert-danger',
            message: message,
         }
      } );
   }
} );
